<template>
  <div class="">
    <!-- <div class="flex justify-between pt-4 lg:px-2 md:px-2 px-2 pb-8">
      <div class="my-auto">
        <p class="text-2xl col-black font-bold">Add Details</p>
      </div>
      <img
        src="../../../assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLocal = false"
      />
    </div> -->
    <div class="lg:px-2 md:px-2 px-2">
      <div>
        <div v-if="!isshowform">
          <div class="mt-4">
            <p class="col-black font-semibold">First Name</p>
            <b-input
              placeholder="First Name"
              class="form-control-muted mb-4"
              v-model="get_volbyid.userId.firstname"
              :disabled="true"
            />
            <p class="col-black font-semibold">Last Name</p>
            <b-input
              placeholder="Last Name"
              class="form-control-muted mb-4"
              v-model="get_volbyid.userId.lastname"
              :disabled="true"
            />
            <div class="">
              <p class="col-black font-semibold">Service Type</p>
              <b-input
                placeholder="Enter Service Type"
                class="form-control-muted mb-4"
                v-model="selectServiceType"
                :disabled="true"
              />
              <!-- <div>
                <b-form-select
                  v-model="selectServiceType"
                  :options="optionService"
                  class="my-3"
                ></b-form-select>
              </div> -->
            </div>
            <!-- <p class="col-black font-semibold">Service Required</p>
            <b-input
              placeholder="Service Required"
              class="form-control-muted mb-4"
              v-model="servicereq"
            /> -->

            <div class="flex gap-4">
              <div class="w-1/2">
                <p class="col-black font-semibold">Date</p>
                <base-input
                  type="date"
                  value="Date"
                  id="example-date-input"
                  class="form-control-muted mb-4"
                  placeholder="Enter Date"
                  v-model="selectedDate"
                  :disabled="true"
                />
              </div>
              <div class="w-1/2">
                <b-form-group label="Time" class="col-black pb font-semibold">
                  <date-picker
                    v-model="selectedTime"
                    format="HH:mm"
                    value-type="format"
                    type="time"
                    class="w-full mb-4"
                    :config="configdateTimePicker"
                    placeholder="hh:mm"
                    :disabled="true"
                  >
                  </date-picker>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div v-show="isshowform">
          <!-- <feather-icon
            icon="ChevronLeftIcon"
            class="cursor-pointer"
            @click="isshowform = false"
          /> -->
          <div>
            <div class="">
              <p class="col-black font-semibold">Address</p>
              <textarea
                class="form-control mb-4"
                placeholder="Enter Address"
                id="exampleFormControlTextarea3"
                rows="3"
                v-model="address"
              ></textarea>
            </div>

            <div class="">
              <p class="col-black font-semibold">State</p>
              <div>
                <b-form-select
                  v-model="selectstate"
                  :options="optionState"
                  class="mb-4"
                ></b-form-select>
              </div>
            </div>
            <div class="flex gap-4">
              <div class="w-1/2">
                <p class="col-black font-semibold">City</p>
                <b-input
                  placeholder="Enter City Name"
                  class="form-control-muted mb-4"
                  v-model="city"
                />
              </div>

              <div class="w-1/2">
                <p class="col-black font-semibold">Pincode</p>
                <b-input
                  placeholder="Enter Pincode"
                  class="form-control-muted mb-4"
                  v-model="pincode"
                  @input="handlePincode"
                  :rules="{
                    numeric: true,
                    required: true,
                    regex: '^[1-9][0-9]*$',
                  }"
                />
                <span class="errorMSG" v-if="pincodeError">{{
                  pincodeError
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center flex item-center justify-center">
          <b-button
            variant="primary"
            class="mr-4 mt-4"
            @click="isshowform = true"
            :disabled="
              selectServiceType === null || selectedTime === '' || date === ''
            "
            v-if="!isshowform"
            >Next</b-button
          >
          <b-button
            variant="primary"
            class="mr-4 mt-4"
            v-if="isshowform"
            @click="isshowform = false"
            >Previous</b-button
          >
          <!-- v-b-modal.modal-6 -->
          <b-button
            variant="primary"
            v-if="isshowform"
            @click="onSessionBook()"
            class="mr-4 mt-4"
            :disabled="
              selectstate === null ||
              city === '' ||
              pincode === '' ||
              address === ''
            "
            >Book Session</b-button
          >

          <b-modal id="modal-6" hide-header ok-only @ok="redirect">
            <img
              src="@/assets/images/MicrosoftTeams-image (8).png"
              class="m-auto h-100px"
            />

            <p class="my-6 fsize25px text-black text-center">
              Your session has been confirmed
            </p>
            <div class="px-5 pb-6 mt-5 flex justify-between mx-auto flex-wrap">
              <div class="flex items-center">
                <p class="font-medium text-black mr-2">
                  <b
                    >Volunteer:{{ get_volbyid.userId.firstname }}
                    {{ get_volbyid.userId.lastname }}</b
                  >
                </p>
                <span></span>
              </div>
              <div class="flex items-center">
                <p class="font-medium text-black mr-2">
                  <b>Date:{{ selectedDate }}</b>
                </p>
                <span></span>
              </div>
              <div class="flex items-center">
                <p class="font-medium text-black mr-2">
                  <b>Time: {{ selectedTime }}</b>
                </p>
                <span></span>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapState } from "vuex";
import { State } from "country-state-city";
import axios from "axios";
export default {
  components: {
    DatePicker,
  },
  props: {
    serviceType: {
      type: String,
      default: "",
    },
    date: {
      type: Object,
      default: {},
    },
    time: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      optionState: [{ value: null, text: "Please select an option" }],
      configdateTimePicker: "",
      isshowform: false,
      address: "",
      city: "",
      state: [],
      pincode: "",
      pincodeError: "",
      selectstate: null,
      selectServiceType: null,
      calendarData: {},
      selectedTime: "",
      selectedDate: "",
      dateTime: "",
      //   selected: "A",
      sessionDateTime: "",
      meetLink: "",
      gLinkCode: "",
    };
  },
  methods: {
    formatDate(date) {
      var d = new Date(date),
        month = "" + d.getMonth(),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;

      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    async onSuccessPayment() {
      // console.log(this.calendarData, "/////// ");
      let payload = {
        volunteerId: this.get_volbyid._id,
        date: this.calendarData.selectedDate,
        time: this.selectedTime,
      };
      try {
        let data = await this.$store.dispatch(
          "respitecare/editvolunteer",
          payload
        );
        this.$bvModal.show("modal-6");
      } catch (error) {}
    },

    onSessionBook() {
      if (this.pincodeError) {
        return false;
      }
      if (this.serviceType === "in-person") {
        this.InpersonSubmit();
      } else if (this.serviceType === "online") {
        // this.onlineSubmit();
        this.handleClick();
      }
    },
    // async getAuth() {
    //   try {
    //     let res = await this.$store.dispatch("google/getAuthUrl", {
    //       redirectURL: window.location.href,
    //       scopes: [
    //         "https://www.googleapis.com/auth/calendar",
    //         "https://www.googleapis.com/auth/calendar.events",
    //       ],
    //     });
    //     console.log(window.location.href, "Window location href");
    //     window.open(res.data, "blank");
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async redirect() {
      this.$bvModal.hide("modal-6");
      this.$bvModal.hide("modal-5");
      this.$router.push({ name: "booking-page" });
      await this.$store.dispatch("respitecare/get_volunteerbyuserid", {
        volunteerId: this.user._id,
      });
    },
    async getToken(code) {
      try {
        let data = await this.$store.dispatch("google/getToken", {
          redirectURL: this.$webURL + "/schedule-page",
          code: code,
        });
        if (data.code === 200) {
          this.$store.commit("google/SET_GOOGLE_AUTH", {
            access_token: data.data,
            scope: decodeURIComponent(this.$route.query.scope),
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onlineSubmit() {
      // this.onSuccessPayment();
      return new Promise(async (resolve, reject) => {
        // let query = this.queries.map((x) => `<li>${x.query}</li>`);

        // let loader = this.$loading.show({});
        try {
          // await this.getAuth();
          await this.getToken(decodeURIComponent(this.$route.query.code));
          // console.log(this.googleAuth.access_token, " : Access Token");
          const { data } = await axios.post(
            "https://www.googleapis.com/calendar/v3/calendars/primary/events?conferenceDataVersion=1&maxAttendees=5&sendNotifications=true",
            {
              end: {
                dateTime: this.sessionDateTime,
              },
              start: {
                dateTime: this.sessionDateTime,
              },
              conferenceData: {
                createRequest: {
                  conferenceSolutionKey: {
                    type: "hangoutsMeet",
                  },
                  requestId: "test",
                },
              },
              attendees: [
                {
                  email: this.user.email,
                  // responseStatus: "accepted",
                },
                {
                  email: this.get_volbyid.userId.email,
                },
              ],
              description: "Description",
              summary: "Caregiver Volunteer Session",
            },
            {
              headers: {
                Authorization: `Bearer ${this.googleAuth.access_token}`, //access_token is gToken
                accept: "application/json",
              },
            }
          );
          // console.log(data);
          this.meetLink = data.hangoutLink;
          // console.log(this.meetLink, " : Google meet Link");
          resolve(data);
          // loader.hide();
        } catch (error) {
          // loader.hide();
          reject(error);
          console.log(error);
        }
      });
    },
    async InpersonSubmit() {
      let d = this.calendarData.selectedDate.split("/");
      let payload = {
        session: this.selectServiceType,
        date: new Date(parseInt(d[2]), parseInt(d[1]), parseInt(d[0])),
        time: this.selectedTime,
        summary: this.summary,
        userId: this.user._id,
        volunteerId: this.get_volbyid._id,
        price: this.sessionPrice,
        city: this.city,
        pincode: isNaN(this.pincode) ? null : parseInt(this.pincode),
        state: this.selectstate,
        address: this.address,
      };
      // console.log(payload);
      try {
        const data = await this.$store.dispatch(
          "respitecare/createbooking",
          payload
        );
        const emailPayload = {
          userEmail: this.user.email,
          volunteerEmail: this.get_volbyid.userId.email,
        };
        const bookingEmail = await this.$store.dispatch(
          "respitecare/email_booking",
          emailPayload
        );
        this.onSuccessPayment();
        // this.$router.push({ name: "map-inside" });
      } catch (err) {
        if (err.response.statusText == "Unauthorized") {
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          this.$router.push("sign-in");
        }
        this.$swal.fire({
          title: "Something went wrong",
          text: err,
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },
    handlePincode(val) {
      // console.log(val);
      if (val.length > 6 || !/^[1-9][0-9]*$/.test(val)) {
        this.pincodeError = "Please enter valid pincode";
      } else {
        this.pincodeError = "";
      }
      // console.log(this.pincodeError);
    },
    async handleClick() {
      let self = this;
      var amount = Number(this.sessionPrice) * 100;
      let d = this.calendarData.selectedDate.split("/");
      var paymentRecord = async (response) => {
        var responcenew = await this.handlePaymentRecord(response);
        this.currTransactionId = responcenew.data._id;

        if (responcenew) {
          const payload = {
            "paymentInfo.paymentAmt": parseInt(Number(this.sessionPrice)),
            "paymentInfo.transactionId": responcenew.data._id,
            "paymentInfo.invoiceId": responcenew.data.orderId,
            "paymentInfo.paymentStatus": "success",

            session: this.selectServiceType,
            date: new Date(parseInt(d[2]), parseInt(d[1]), parseInt(d[0])),
            time: this.selectedTime,
            summary: this.summary,
            userId: this.user._id,
            volunteerId: this.get_volbyid._id,
            price: this.sessionPrice,
            city: this.city,
            pincode: isNaN(this.pincode) ? null : parseInt(this.pincode),
            state: this.selectstate,
            address: this.address,
          };
          // console.log(payload);
          try {
            const data = await this.$store.dispatch(
              "respitecare/createbooking",
              payload
            );

            if (data.code == 200) {
              let TransPayload = {
                _id: responcenew.data._id,
                transactionstatus: "Success",
              };

              await this.$store.dispatch(
                "transaction/UpdateTransaction",
                TransPayload
              );

              // loader.close();
              // console.log("payment success");
              this.onlineSubmit();

              const status = await this.$store.dispatch(
                "respitecare/editbooking",
                {
                  _id: data.data._id,
                  orderStatus: "success",
                  meetLink: this.meetLink,
                }
              );
              if (status.code == 200) {
                this.$swal.fire({
                  title: "Order Placed!",
                  text: "Your order has been placed Successfully!",
                  icon: "success",
                  showConfirmButton: false,
                  showCancelButton: false,
                  timer: 2000,
                });
                this.onSuccessPayment();
              } else if (status.code == 401) {
                this.$router.push({ name: "signin" });
                this.$swal.fire({
                  title: "Session Expired",
                  text: "Your session has ended and for security reasons, we request you to login again",
                  icon: "warning",
                  confirmButtonColor: "#830c81",
                  showCancelButton: false,
                });
              }
            }
            // loader.close();
          } catch (error) {
            // loader.close();
            console.log(error);
          }
        }
      };
      this.$store
        .dispatch("payment/CreateOrderPayment", {
          amount: Number(Math.round(amount)),
        })
        .then(async (_) => {
          console.log(_);
          if (Object.keys(_.data).length == 0) {
            // console.log("Payment failed");
            return;
          }
          var options = {
            key: process.env.RAZORPAY_KEY_ID,
            amount: _.data.amount.toString(),
            currency: "INR",
            name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
            description: `Session Booking `,
            order_id: _.data.id,
            handler: function (response) {
              paymentRecord(response);
            },
            prefill: {
              name: `${this.user.firstname || ""} ${this.user.lastname || ""}`,
              email: `${this.user.email || ""}`,
              phone: `${this.user.mobile || ""}`,
            },
          };
          var rzp1 = new Razorpay(options);
          rzp1.on("payment.failed", async function (response) {
            // console.log("FAILEDTRANSACTION");
            self.handleFaliedTransaction();
          });
          rzp1.open();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async handlePaymentRecord(responce) {
      try {
        let payload = {
          transactionId: responce.razorpay_signature,
          transactionstatus: "In-Progress",
          transactionMode: "online",
          orderId: responce.razorpay_order_id,
          razorpayKey: {
            razorpay_payment_id: responce.razorpay_payment_id,
            razorpay_order_id: responce.razorpay_order_id,
            razorpay_signature: responce.razorpay_signature,
          },
        };
        const transactionrecord = await this.$store.dispatch(
          "transaction/CreateTransaction",
          payload
        );
        this.currTransactionId = transactionrecord.data._id;
        return transactionrecord;
      } catch (err) {
        console.log(err);
      }
    },
    async handleFaliedTransaction() {
      let TransPayload = {
        _id: this.currTransactionId,
        transactionstatus: "Failed",
      };
      let data = await this.$store.dispatch(
        "transaction/UpdateTransaction",
        TransPayload
      );
    },
    closeModal() {
      this.$emit("close");
    },
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
    ...mapState("respitecare", {
      get_volbyid: "get_volbyid",
    }),
    ...mapState("eLearning", {
      profileData: "profileData",
    }),
    ...mapState("auth", {
      user: "user",
    }),
    ...mapState("auth", ["sessionPrice"]),
    ...mapState("google", ["googleAuth"]),
  },
  async mounted() {
    // console.log(this.sessionPrice, "this.sessionPrice");

    this.state = await State.getStatesOfCountry("IN").map((state) => {
      return { value: state.name, text: state.name };
    });
    this.optionState = [...this.optionState, ...this.state];
    this.selectServiceType = this.serviceType;
    this.calendarData = this.date;
    let d = this.calendarData.selectedDate.split("/");
    let date = new Date(parseInt(d[2]), parseInt(d[1]), parseInt(d[0]));
    let date2 = new Date(parseInt(d[2]), parseInt(d[1] - 1), parseInt(d[0]));
    this.selectedDate = this.formatDate(date);
    this.selectedTime = this.time;
    let time = this.time.slice(0, 5) + ":00";
    if (this.time.includes("pm")) {
      let convert = time.split(":");
      convert[0] = Number(convert[0]) + 12;
      time = convert.join(":");
      this.sessionDateTime = new Date(
        `${date2.toString().slice(4, 15)} ${time}`
      );
    } else {
      this.sessionDateTime = new Date(
        `${date2.toString().slice(4, 15)} ${time}`
      );
    }
  },
};
</script>
<style>
.errorMSG {
  color: red;
  font-size: small;
}
.mx-datepicker {
  width: 100%;
}
.mx-input {
  height: 42px !important;
}
.mx-input:disabled {
  color: #525f7f;
  background-color: #e9ecef;
}
.col-form-label {
  padding-bottom: 3px !important;
}
</style>
